var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"text-center"},[_c('b-col',[_c('b-spinner',{attrs:{"label":"Loading...","variant":"primary"}}),_c('p',{staticClass:"text-primary"},[_vm._v("Please wait...")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }